


























import {
    defineComponent,
    reactive,
    toRefs,
    computed,
} from '@vue/composition-api';
import maskModal from '@/components/mask-modal/index.vue';

export default defineComponent({
    props: {
        isShowMask: {
            type: Boolean,
            default: false,
        },
        scopeSecret: {
            type: Object,
            required: true,
        },
    },
    model: {
        prop: 'isShowMask',
        event: 'update',
    },
    components: {
        maskModal,
    },
    setup(props, context) {
        const isShow = computed({
            get: () => {
                return props.isShowMask;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });
        function goDescPage() {
            // todo 跳到使用说明页面
        }
        function downloadPng(path: string) {
            const a = document.createElement('a');
            a.href = `https://${window.location.host}/portal/file/secure/img/${path}`;
            a.download = path;
            a.click();
        }
        return {
            isShow,
            goDescPage,
            downloadPng,
        };
    },
});
